import { BaseApi } from "../shared/api";
import * as types from "./actionTypes";
import * as url from "./apiUrls";

export function commentsCount(type) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user } = getState();

    api.getRequest(
      url.commentsCount(user.id, type),
      response => {
        let payload = {};
        payload[type] = response.data.count;
        dispatch({type: types.CHECK_COMMENTS_COUNT, payload: payload});
      }
    )
  }
}

export function submitFeedback(body, onSuccess) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user } = getState();

    return api.postRequest(
      url.feedback(user.id),
      body,
      response => {
        onSuccess(response);
        dispatch({type: types.SUBMIT_FEEDBACK, payload: body});
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/feedbacks/actions.js